import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import type { OrgType, Tenant } from '@up2d8/contracts';
import { setOrgType } from './i18n';
import { useSession } from './session';

/**
 * Houdt de woorden van de app gelijk met het type van het eigen bedrijf (ORG-2).
 *
 * Een uur gecachet, net als de vlaggen: een type wijzigt hoogstens een paar keer in het leven van
 * een organisatie. Zonder aanmelding of zonder het recht om het eigen bedrijf te zien (het
 * platformbeheer) blijven het de woorden van een fabriek.
 */
export function useOrgTypeTerms(): void {
  const orgType = useOrgType();
  useEffect(() => {
    setOrgType(orgType);
  }, [orgType]);
}

/** Het type van het eigen bedrijf; `factory` zolang het onbekend is (ORG-2, VER-1). */
export function useOrgType(): OrgType {
  const { api, has, profile } = useSession();
  const enabled = Boolean(profile) && has('tenants.tenant.view');

  const tenant = useQuery({
    // Per bedrijf: wie wisselt van bedrijf (ACC-1), krijgt de woorden van het nieuwe.
    queryKey: ['tenant', 'org-type', profile?.tenantId ?? null],
    enabled,
    staleTime: 60 * 60 * 1000,
    retry: false,
    queryFn: async () => {
      const { data, error } = await api.GET('/api/v1/tenant');
      if (error || !data) return null;
      return (data as Tenant).orgType;
    },
  });

  return enabled && tenant.data ? tenant.data : 'factory';
}
